<template>
  <div class="user-status" v-on-clickaway="away">
    <div class="user-status__header" :class="{ 'user-status__header--active': click }" @click="toggleDropdown">
      <div>
        <slot name="title"></slot>
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </div>
      <!-- <div class="user-status__image" :data-user-status="userStatus">
        <slot name="image"></slot>
      </div> -->
    </div>
    
    <div class="user-status__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],
  props: {
    userStatus: {
      type: String,
      required: true

    }
  },
  data () {
    return {
      click: false
    }
  },
  methods: {
    toggleDropdown () {
      this.click = !this.click
    },
    away () {
      if (this.click) {
        this.click = false;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/layout/UserStatus.vue